import { Dialog } from '@mui/material';

type Props = {
  onClose: () => void;
  src: string;
  alt: string;
};

export default function FullScreenMediaModal({ onClose, src, alt }: Props) {
  return (
    <Dialog
      sx={{
        '& .MuiDialog-paper': {
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          alignItems: 'center',
          justifyContent: 'center',
        },
      }}
      fullScreen
      open
      onClose={onClose}
      onClick={onClose}
    >
      <img
        onClick={(e) => e.stopPropagation()}
        src={src}
        alt={alt}
        style={{
          objectFit: 'scale-down',
          maxWidth: '100%',
          maxHeight: '100%',
        }}
      />
    </Dialog>
  );
}
